import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import './SubscribedPackageCard.css';


const SubscribedPackageCard = ({ subscriptionData }) => {
  const navigate = useNavigate();
  const { apiService } = useParams();
  const features = subscriptionData?.featurs || [];
  const result = subscriptionData.result[0];
  console.log(apiService);

  const handleUnsubscribe = async () => {
    try {
      // Static `msisdn` for now
      const msisdn = JSON.parse(sessionStorage.getItem("msisdn"));

      // Confirm before unsubscribing
      const confirmResult = await Swal.fire({
        title: 'Are you sure?',
        text: 'Do you really want to unsubscribe from this service?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, unsubscribe',
        cancelButtonText: 'Cancel',
      });

      if (!confirmResult.isConfirmed) return;

      // API call
      const response = await fetch('https://digital.webdoc.com.pk/Promotion/public/api/v1/service/un-subscribe', {
        method: 'POST',

        body: JSON.stringify({
          api_service: apiService, // Use the value from useParams
          msisdn,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to unsubscribe');
      }

      const data = await response.json();

      // Check for success
      if (data.statusCode === 100 && data.payLoad?.IS_UN_SUB === 'Y') {
       const result =await Swal.fire({
          title: 'Unsubscribed!',
          text: data.payLoad.message,
          icon: 'success',
          allowOutsideClick: false,
          confirmButtonText: 'OK',
        });
        if (result.isConfirmed) {
          
          navigate(-1);
        }


      } else {
        await Swal.fire({
          title: 'Error',
          text: data.statusMessage.join(', '),
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
    } catch (error) {
      console.error('Error during unsubscribe:', error);
      Swal.fire({
        title: 'Error',
        text: 'An error occurred while unsubscribing. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };
  return (
    <div className="subscribed-card-container ">
      <div className="subscribed-card">
        <div className="card-body p-2">
          {/* <h4 className="card-title text-center mb-2">Subscription Details</h4> */}
          <div class="row">
            <div class="col-8">
              <h6>{result.cellno}</h6>
            </div>
            <div class="col-4 text-right">
              <span class=" ml-3 badge bg-success">Active</span>
            </div>

          </div>
          <div class="row">
            <div class="col-6">Subscribe Date : </div>
            <div class="col-6">{result.sub_dt}</div>

            <div class="col-12">
              <hr />
              <button className="btn-unsubscribe" onClick={handleUnsubscribe}>
                Unsubscribe
              </button>

            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="d-flex flex-column dark-border rounded-border bg-success p-3 text-white text-center">
                <p className="">
                  For more information Dail</p>
                {apiService === "API_RSA_CI" || apiService === "API_RSA_BI" ? <h3><i class="fa fa-phone"></i> 7832</h3> : <h3><i class="fa fa-phone"></i> 9362</h3>}
                {/* <strong
                className="float-end"
                style={{ fontSize: "15px", color: "white" }}
              >
              9362
              </strong> */}
              </div>
            </div>
          </div>
          <h4 class="text-center">Fetaures</h4>
          <p className="card-text" dangerouslySetInnerHTML={{ __html: features }}></p>

        </div>
      </div>
    </div>
  );
};

export default SubscribedPackageCard;
